import whenDomReady from 'when-dom-ready';
import CountUp from 'countup.js';

function initialise() {
  const percentageElement = document.querySelector('.js-account-percentage');
  const avatars = Array.from(document.querySelectorAll('.js-account-avatar'));
  let countUp = null;

  if (percentageElement !== null) {
    const percentage = percentageElement.getAttribute('data-percentage');
    countUp = new CountUp(percentageElement, 0, percentage, 0, '1');
  }

  window.setTimeout(() => {
    Array.forEach(avatars, avatar => avatar.classList.add('animated'));
  }, 1000);

  if (countUp !== null) {
    window.setTimeout(() => {
      countUp.start();
    }, 2000);
  }
}

whenDomReady().then(initialise);

Sys.WebForms.PageRequestManager.getInstance().add_endRequest(initialise);
